import { theme } from '@moonpig/launchpad-theme-mission-control'

export const studioTheme = {
  ...theme,
}
